export default "__VITE_ASSET__DmtrCS9K__"